import { h, Host } from "@stencil/core";
import { ICON_NAMESPACE } from "../../../icons/namespace";
/**
 * A dropdown to display more actions than can be reasonably fit in a row.
 * All child actions must have the `dropdownItem` prop set.
 */
export class ESActionDropdown {
  constructor() {
    this.toggleDropdown = () => {
      this.dropdownOpen = !this.dropdownOpen;
    };
    this.closeDropdown = () => {
      this.dropdownOpen = false;
    };
    this.icon = [ICON_NAMESPACE, 'more'];
    this.disabled = false;
    this.dropdownOpen = false;
  }
  render() {
    return (h(Host, null, h("es-button", { disabled: this.disabled, variant: 'minimal', onClick: this.toggleDropdown, onMouseDown: (e) => e.preventDefault() }, h("es-icon", { icon: this.icon, size: 20 })), h("es-popover", { arrow: true, trapFocus: true, closeOnEsc: true, closeOnClickOutside: true, closeOnBlur: true, onRequestClose: this.closeDropdown, open: this.dropdownOpen, placement: 'bottom-end', offset: 8 }, h("slot", null))));
  }
  static get is() { return "es-action-dropdown"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["es-action-dropdown.css"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["es-action-dropdown.css"]
    };
  }
  static get properties() {
    return {
      "icon": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "IconDescription",
          "resolved": "[namespace: string | symbol, name: string] | string",
          "references": {
            "IconDescription": {
              "location": "import",
              "path": "../../es-icon/types",
              "id": "src/components/es-icon/types.ts::IconDescription"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "The icon to show for the action."
        },
        "attribute": "icon",
        "reflect": false,
        "defaultValue": "[ICON_NAMESPACE, 'more']"
      },
      "disabled": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "If the dropdown should be disabled."
        },
        "attribute": "disabled",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get states() {
    return {
      "dropdownOpen": {}
    };
  }
}
//# sourceMappingURL=es-action-dropdown.js.map
